import React from 'react';
import styled from 'styled-components';

import {
  BUTTON_THEMES,
  BUTTON_TYPES,
  ICON_TYPES,
} from '../../../shared/constants';

import PrimaryButton from '../../atoms/primary-button/PrimaryButton';

import { DEQ_COMPS } from '../../../utils/deq';
import { ReactMarkdownExtended } from '../../../utils/generic';

import mq from '../../../styles/breakpoints';
import { Body, IntroCopyStyles } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

export interface WizardIntroProps {
  body: string;
  buttonLabel?: string;
  onButtonClick: () => void;
}

const WizardIntro = ({
  body,
  buttonLabel,
  onButtonClick,
}: WizardIntroProps) => (
  <WizardIntroContainer>
    <StyledBody data-testid="body-text">
      <ReactMarkdownExtended componentType={DEQ_COMPS.wizardIntro}>
        {body}
      </ReactMarkdownExtended>
    </StyledBody>
    <ButtonWrapper>
      <PrimaryButton
        type={BUTTON_TYPES.internal}
        icon={ICON_TYPES.none}
        buttonTheme={BUTTON_THEMES.highlight}
        label={buttonLabel || 'Start'}
        onButtonClick={onButtonClick}
      />
    </ButtonWrapper>
  </WizardIntroContainer>
);

export default WizardIntro;

const WizardIntroContainer = styled.div`
  padding: ${Spacings.S};

  ${mq.from.breakpoint.M`
    padding: 0;
  `}
`;

const ButtonWrapper = styled.div`
  display: block;
  padding-top: ${Spacings.M};
  width: 100%;

  ${mq.from.breakpoint.M`
    padding-top: ${Spacings.XL};
    width: 100%;
  `}
`;

const StyledBody = styled(Body)`
  > h3 {
    ${IntroCopyStyles}
  }
`;
